import React from 'react';
import { actions, elements } from '@ecosystem/newron-design-system';
const { Icon } = elements;
const { IconButton } = actions;

type AddClassButtonProps = {
  testId: string;
  onClick: () => void;
  isShowing: boolean;
};

export const AddClassButton = ({ testId, onClick, isShowing }: AddClassButtonProps) => {
  if (!isShowing) {
    return null;
  }

  return (
    <IconButton testId={testId} onClick={onClick}>
      <Icon.icons.Add />
    </IconButton>
  );
};
